import React, { useState, useEffect } from 'react';
import useAsync from '../hooks/useAsync';
import FeedbackServices from '../services/FeedbackServices';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import ViewFeedback from './View Model/ViewFeedback';
import StarRating from './Rating/StarRating'; // Importing the custom StarRating component
import ReactPaginate from 'react-paginate'; // Import ReactPaginate

Modal.setAppElement('#root');

function Feedback() {
  const { data, error, isLoading, run } = useAsync(FeedbackServices.getFeedback);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [ratingFilter, setRatingFilter] = useState(''); // New state for rating filter
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // Customize items per page

  // Apply search, rating filter, and pagination
  useEffect(() => {
    if (data?.data) {
      const filtered = data.data.filter(feedback => {
        const name = feedback?.user?.firstName?.toLowerCase() || '';
        const comment = feedback?.comment?.toLowerCase() || '';
        const mobileNo = feedback?.user?.mobileNo?.toString() || '';
        const matchesSearch = name.includes(searchTerm.toLowerCase()) ||
          comment.includes(searchTerm.toLowerCase()) ||
          mobileNo.includes(searchTerm);
        const matchesRating = ratingFilter ? feedback.rating === parseInt(ratingFilter) : true;
        return matchesSearch && matchesRating;
      });

      setFilteredData(filtered);
      setCurrentPage(0); // Reset to the first page when filters change
    }
  }, [data, searchTerm, ratingFilter]);

  const handleViewDetails = (user) => {
    setSelectedEdit(user);
    setIsEditModalOpen(true);
  };

  const handleDelete = (feedback) => {
    setSelectedEdit(feedback);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRatingFilterChange = (event) => {
    setRatingFilter(event.target.value);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const paginatedData = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString();
  }

  function truncateText(text, limit) {
    const words = text.split(' ');
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '...';
    }
    return text;
  }

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Feedback List <span className="badge bg-orange">{filteredData.length}</span>                    </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Feedback
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">




          </div>
        </div>

        <div className="container-box px-0">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6 col-6  '>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className='form-control'
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
              <div className='col-md-6 col-6  '>
                <div className="input-field">
                  <select className="form-select selectcustum" value={ratingFilter} onChange={handleRatingFilterChange}>
                    <option value="">Filter by Rating</option>
                    <option value="5">5 Star</option>
                    <option value="4">4 Star</option>
                    <option value="3">3 Star</option>
                    <option value="2">2 Star</option>
                    <option value="1">1 Star</option>
                  </select>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>USERNAME</th>
                  <th className="w-50">BRIEF</th>
                  <th>SERVICENAME</th>
                  <th>MOBILE NO</th>
                  <th>DATE</th>
                  <th>RATING</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              {paginatedData.length > 0 ? (
                <tbody>
                  {paginatedData.map((feedback, index) => (
                    <tr key={index}>
                      <td>{currentPage * itemsPerPage + index + 1}</td>
                      <td>
                        <img src={feedback?.image ? `${process.env.REACT_APP_URL}${feedback?.image}` : 'img/profile-img.png'}
                          alt="" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                      </td>
                      <td>{`${feedback?.user?.firstName || "N/A"} ${feedback?.user?.lastName || ""}`.trim() || "N/A"}</td>
                      <td className="address">{truncateText(feedback?.comment, 20)}</td>
                      <td>{feedback?.service?.title}</td>
                      <td>{feedback?.user?.mobileNo}</td>
                      <td className="payment">{formatDateTime(feedback?.createdAt)}</td>
                      <td>
                        <StarRating rating={feedback?.rating} />
                      </td>
                      <td className="status-toggle">
                        <TogalButtonForStatus data={feedback} page="feedback" onSuccess={() => run()} />
                      </td>
                      <td>
                        <div className="action_toggle_outer">
                          <button
                            className="action_toggle"
                            onClick={() => toggleActionMenu(index)}
                          >
                            <i className="fa fa-ellipsis-v" />
                          </button>
                          {activeIndex === index && (
                            <div className="action_toggle_content product-edit show d-block">
                              <ul className="list-unstyled">
                                <li>
                                  <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                    <i className="fa fa-close" />
                                  </button>
                                </li>
                                <li>
                                  <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(feedback)}>
                                    View
                                  </button>
                                </li>
                                <li>
                                  <button className="reject" onClick={() => handleDelete(feedback)}>
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr><td colSpan="9">No Feedback Found</td></tr>
                </tbody>
              )}
            </table>
          </div>
          {/* Pagination Component */}
          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            breakClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            breakLinkClassName={'page-link'}
          />
        </div>

        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewFeedback feedback={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="feedback" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>


      </div>
    </>
  );
}

export default Feedback;
